<div id="oie-options">
  <div id="toolbar-buttons">
    <div class="group group_crop">
      <div v-show="getEditor.cropMode" id="oieSliderConteiner">
        <div @click="changeSlider(-5)" class="sliderZoom sliderZoomOut">
          <appAwesomeIcon icon="image" useClass="fa fa-picture-o" />
        </div>
        <div id="oieSlider">
          <div id="oieSliderHandle" class="ui-slider-handle"></div>
        </div>
        <div @click="changeSlider(+5)" class="sliderZoom sliderZoomIn">
          <appAwesomeIcon icon="image" useClass="fa fa-picture-o" />
        </div>
        <div id="sliderText" v-html="getActiveSliderValue"></div>
      </div>
      <div
        v-show="getEditor.cropMode"
        id="t-cropMode"
        @click="toggleCropMode(0) "
        :class="{'t-button': true}"
      >
        <div class="t-icon"></div>
      </div>
      <div
        v-show="!getEditor.cropMode"
        id="t-normalMode"
        @click="toggleCropMode(1)"
        :class="{'t-button': true, style1: true} "
      >
        <div class="t-icon"></div>
      </div>
    </div>
    <div class="group">
      <div
        id="t-margins"
        @click="enableMarginView(true) "
        :class="{'t-button': true, active:getEditor.marginView}"
      >
        <div class="t-icon"></div>
      </div>
      <div
        id="t-crop"
        @click="enableMarginView(false)"
        :class="{'t-button': true, style1: true, active: !getEditor.marginView} "
      >
        <div class="t-icon"></div>
      </div>
    </div>
    <div class="group">
      <div
        id="t-portret"
        :class="{'t-button': true, active: isPortret}"
        @click="doPortret"
      >
        <div class="t-icon"></div>
      </div>
      <div
        id="t-landscape"
        :class="{'t-button': true, style1: true, active:isLandscape}"
        @click="doLandscape"
      >
        <div class="t-icon"></div>
      </div>
    </div>
    <div v-if="0" class="group">
      <div id="t-rotate" @click="rotateImage()" class="t-button style1">
        <div class="t-icon"></div>
      </div>
    </div>
    <div class="group bck_group">
      <div
        @click="toggleBckMode()"
        id="change-background"
        :class="{'t-button': true, style1: true, active: getEditor.bckMode} "
      >
        <appAwesomeIcon icon="file-image" useClass="fa fa-file-image-o t-icon" />
      </div>
    </div>
    <div class="group delete_group">
      <div
        @click="deleteObject()"
        id="delete-object"
        :class="{'t-button': true, style1: true} "
      >
        <appAwesomeIcon icon="trash-alt" useClass="fa fa-trash-o t-icon" />
      </div>
    </div>
  </div>
  <div id="image-quality">
    <div class="label">{{ $t('Quality:') }}</div>
    <div :class="'quality-stars q' + getQuality"></div>
    <div class="quality-info info-button">
      <div class="qi-tooltip info-tooltip">
        <div class="qi-content info-content">
          <div class="qi-stars qi-5stars">
            {{ $t('Die allerbeste Qualität.') }}
          </div>
          <div class="qi-stars qi-4stars">
            {{ $t('Sehr gute Qualität.') }}
          </div>
          <div class="qi-stars qi-3stars">
            {{ $t('Akzeptabel aber vielleicht etwas unscharf.') }}
          </div>
          <div class="qi-stars qi-2stars">
            {{ $t('Nur mäßige Qualität.') }}
          </div>
          <div class="qi-stars qi-1stars">
            {{ $t('Ganz schlechte Qualität, unscharf und pixelig.') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
